import axios from 'axios';

const axiosInstanceConfig = {
  headers: {
    Authorization: `Bearer ${localStorage.getItem('jwt')}`,
    'Accept-Version': process.env.API_VERSION,
  },
};

axiosInstanceConfig.baseURL = process.env.ROOT_API;

const axiosInstance = axios.create(axiosInstanceConfig);

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/helpers/http-common.js